import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { SubscriptionEntitlementService } from 'src/app/core/services/subscription-entitlement.service';

@Injectable({ providedIn: 'root' })
export class SubscriptionEntitlementGuard implements CanActivate {
  constructor(
    private readonly entitlement: SubscriptionEntitlementService,
    private readonly router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.entitlement.canAccessWorkspace().pipe(
      take(1),
      map(access => access ? true : this.router.createUrlTree(['/']))
    );
  }
}
